// /src/config/menuConfig.ts

/**
 * Single clickable menu link
 * - label: text shown in menu
 * - url: route or external URL
 * - spa: if true, intended for app route usage
 */
type MenuLink = {
  label: string;
  url: string;
  spa?: boolean;
};

/**
 * A single column inside a mega menu item
 */
type MenuColumn = {
  heading: string;
  links: MenuLink[];
};

/**
 * Top-level menu item
 */
export type MenuItem = {
  title: string;
  columns: MenuColumn[];
};

/**
 * Whole menu configuration
 */
type MenuConfig = {
  branding: {
    homeUrl: string;
    logoSrc: string;
    logoAlt: string;
  };
  search: {
    action: string;
    suggestions: { label: string; url: string }[];
  };
  items: MenuItem[];
};

const menu: MenuConfig = {
  branding: {
    homeUrl: "http://localhost/wordpress/ar/",
    logoSrc: "/dga_v2/assets/img/moiaIcons/MOIALOGO.png",
    logoAlt: "النظام الإلكتروني لإدارة شؤون المساجد",
  },

  search: {
    action: "http://localhost/wordpress/ar/",
    suggestions: [
      { label: "Uncategorized", url: "http://localhost/wordpress/ar/?cat=1" },
    ],
  },

  items: [
  // ==============================
  // MOSQUE (already working style)
  // ==============================
  {
    title: "فرص عقود الصيانة",
    columns: [
      {
        heading: "فرص عقود الصيانة",
        links: [
          {
            label: "فرص عقود الصيانة",
            url: "/service/mosque-contribution",
            spa: true,
          },
          {
            label: "خريطة فرص المساهمة في النظافة والصيانة",
            url: "/mosque/donation-opportunities-map",
            spa: true,
          },
        ],
      },
    ],
  },

  // ==============================
  // LAND (NEW — SAME STRUCTURE)
  // ==============================
  {
  title: "الأراضي المتاحة لبناء مسجد",
  columns: [
    {
      heading: "الأراضي المتاحة لبناء مسجد",
      links: [
        {
          label: "الأراضي المتاحة لبناء مسجد",
          url: "/service/available-lands", // IMPORTANT
          spa: true,
        },
        {
          label: "خريطة الأراضي",
          url: "/benefaction/lands/map",
          spa: true,
        },
      ],
    },
  ],
},

  // ==============================
  // SEARCH (existing)
  // ==============================
  {
    title: "البحث عن المساجد",
    columns: [
      {
        heading: "البحث عن المساجد",
        links: [
          {
            label: "البحث عن المساجد",
            url: "/service/mosque-search",
            spa: true,
          },
        ],
      },
    ],
  },
]
};

export default menu;